// Module
var code = "<c-custom-player data-url=\"https://vimeo.com/225381576\" js-template></c-custom-player>";
// Exports
export default code;